import { DeleteLinkConfirmation } from "@circle-react/components/Spaces/SidebarV2/CommunityMenu/Links/DeleteLinkConfirmation";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Menu } from "@circleco/compass/components/Menu";

import { t } from "@/i18n-js/instance";

import { COMPASS_DEFAULT_INTERACTIVE_HOVER_CLASSES } from "../constants";
import { useAddLinkModal } from "./AddLinkModal";
import type { SidebarLink } from "./LinkItem";

export interface LinkOptionsMenuProps {
  link: SidebarLink;
  onOpenChange?: (isOpen: boolean) => void;
}

export const LinkOptionsMenu = ({
  link,
  onOpenChange,
}: LinkOptionsMenuProps) => {
  const [shouldShowDeleteConfirmation, toggleDeleteConfirmation] =
    useBoolean(false);
  const addLinkModal = useAddLinkModal();

  return (
    <>
      <span className={COMPASS_DEFAULT_INTERACTIVE_HOVER_CLASSES}>
        <Menu
          align="start"
          options={[
            {
              label: t("edit"),
              onClick: () => {
                void addLinkModal.show({ isEdit: true, link });
              },
            },
            {
              danger: true,
              label: t("delete"),
              onClick: toggleDeleteConfirmation,
            },
          ]}
          onOpenChange={onOpenChange}
          trigger={
            <IconButton
              aria-label={t("community_sidebar.view_sidebar_link_options")}
              icon="dot-menu"
              size="sm"
              type="button"
              variant="ghost"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
              }}
            />
          }
        />
      </span>

      <DeleteLinkConfirmation
        isOpen={shouldShowDeleteConfirmation}
        link={{ id: String(link.id), name: link.name }}
        onClose={toggleDeleteConfirmation}
      />
    </>
  );
};
